import {Component, Input, OnInit} from '@angular/core';
import {ApprovalPending} from '../../../shared/dto/approval-pending';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import Swal from "sweetalert2";
import {ApprovalService} from '../../../service/approval.service';
import {FormControl, FormGroup} from '@angular/forms';
import {DuplicateApplicantDataModel} from '../../../shared/dto/duplicate-applicant-data.model';
import {NationalityModel} from '../../../shared/dto/nationality.model';
import {NationalityService} from '../../../shared/service/nationality.service';
import {ApplicantRequestSearchModel} from '../../../model/applicantRequestSearchModel';
import {ApplicantRequestService} from '../../../service/applicant-request.service';
import {MatTableDataSource} from '@angular/material/table';
import {DocumentTypeModel} from '../../../shared/dto/document-type.model';
import {DocumentDetailsService} from '../../../service/document-details.service';

@Component({
  selector: 'app-duplicate-applicant-request',
  templateUrl: './duplicate-applicant-request.component.html',
  styleUrls: ['./duplicate-applicant-request.component.scss']
})
export class DuplicateApplicantRequestComponent implements OnInit {
  @Input() applicationId: number;
  applicantSearchForm: FormGroup;
  public approvalPending: DuplicateApplicantDataModel;
  public nationality: NationalityModel[];
  female: boolean;
  male: boolean;
  userName: string;
  userRole: string;
  isCancelled: boolean = false;
  notCancelled: boolean = false;
  debarred: boolean = false;
  notDebarred: boolean = false;
  public showdiv: boolean = false;
  applicantRequestSearchDetails: ApplicantRequestSearchModel;
  retrievedImage: string;
  base64Data: string;
  signature: string;
  imgrighthand: string;
  imglefthand: string;
  thumbright: string;
  thumbleft: string;
  isLoading: boolean = false;
  isLoading1: boolean = false;
  isLoading2: boolean = false;
  isLoading3: boolean = false;
  isLoading4: boolean = false;
  public page: any = [];
  public documentTypeModel: DocumentTypeModel[];
  displayedColumns: string[] = ['description','action'];
  dataSource: MatTableDataSource<any>;
  docType: DocumentTypeModel = new DocumentTypeModel();
  documentDetails: any = [];
  public loader: boolean = false;
  public showdiv2: boolean = false;

  constructor(private approvalService: ApprovalService, private tokenStorageService: TokenStorageService,
              private nationalityService: NationalityService,
              private applicantRequestService: ApplicantRequestService,private documentDetailsService: DocumentDetailsService,) {
  }

  ngOnInit() {
    this.getDocumentType();
    this.applicantSearchForm = new FormGroup({
      remark: new FormControl(null),
      appRefNo: new FormControl(null),
      appType: new FormControl(null),
      status: new FormControl(null),
      createDate: new FormControl(null),
      cdcNo: new FormControl(null),
      sidNo: new FormControl(null),
      sidIssueDate: new FormControl(null),
      sidExpDate: new FormControl(null),
      fullName: new FormControl(null),
      familyName: new FormControl(null),
      givenName: new FormControl(null),
      initialName: new FormControl(null),
      nicIssueDate: new FormControl(null),
      dob: new FormControl(null),
      gender: new FormControl(null),
      nic: new FormControl(null),
      birthPlace: new FormControl(null),
      nationality: new FormControl(null),
      bioRefNo: new FormControl(null),
      photoDate: new FormControl(null),
      photoExpDate: new FormControl(null),
      cancelSid: new FormControl(null),
      sidLostReason: new FormControl(null),
      debarredSid: new FormControl(null),
    });

    this.getNationality();
    this.onSearch();
    this.getApplicantDetails();
    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.userRole=this.tokenStorageService.getUserObjectToken().userroleCode;
  }

  private getNationality(): void {
    this.nationalityService.getAllNationalities().subscribe(
      (data: NationalityModel[]) => {
        this.nationality = data;
      }
    );
  }

  getApplicantDetails(){
    this.isLoading3 = true;
    this.approvalService.getApplicantDetails(this.applicationId).subscribe(
      (data: ApplicantRequestSearchModel) =>{
        this.applicantRequestSearchDetails = data;
        this.isLoading3 = false;
        this.applicantSearchForm.patchValue(
          {
            bioRefNo: this.applicantRequestSearchDetails.reference,
            photoDate: this.applicantRequestSearchDetails.expiryDate,
            photoExpDate: this.applicantRequestSearchDetails.expiryDate,
          }
        );
        this.retrievedImage = this.applicantRequestSearchDetails.image;
        this.signature = this.applicantRequestSearchDetails.imgsignature;
        this.imgrighthand = this.applicantRequestSearchDetails.imgrighthand;
        this.imglefthand = this.applicantRequestSearchDetails.imglefthand;
        this.thumbright = this.applicantRequestSearchDetails.thumbright;
        this.thumbleft = this.applicantRequestSearchDetails.thumbleft;

        this.base64Data = window.atob(this.retrievedImage);
      }
    )
  }

  getDocumentType() {
    this.isLoading = true;
    this.applicantRequestService.getDocumentType(this.applicationId).subscribe(
      (result: any ) => {
        this.isLoading = false;
        this.documentTypeModel = result;
        this.dataSource = new MatTableDataSource(this.documentTypeModel);
      }
    );
  }

  getPages(documentTypeCode) {
    this.loader = true;
    this.docType.appRefID = this.applicationId;
    this.docType.documentTypeCode = documentTypeCode;
    this.documentDetailsService.getPages(this.docType).subscribe(
      (data) => {
        if (data !== null && data !== "") {
          this.page = data;
          this.page.content.forEach(element => {
            this.documentDetails.push(element);
          });
        }
        this.loader = false;
      },
      error => {
        this.loader = false;
        Swal.fire(`Internal Server Error`, error.message, "error");
      }
    );
  }

  onSearch() {
    this.isLoading = true;
    this.isLoading1 = true;
    this.isLoading2 = true;
    this.isLoading4 = true;
    this.approvalService.searchDuplicateApplicantData(this.applicationId).subscribe(
      (data: any ) => {
        this.approvalPending = data;
        console.log(this.approvalPending);
        this.isLoading = false;
        this.isLoading1 = false;
        this.isLoading2 = false;
        this.isLoading4 = false;
        this.applicantSearchForm.patchValue(
          {
            remark: this.approvalPending.remark,
            status: this.approvalPending.stage,
            appType: this.approvalPending.type,
            nic: this.approvalPending.nic,
            createDate: this.approvalPending.createdDate.toString().substring(0, 10),
            fullName: this.approvalPending.name,
            appRefNo: this.approvalPending.appRefNo,
            cdcNo: this.approvalPending.cdcNo,
            sidNo: this.approvalPending.sidNo,
            sidIssueDate: this.approvalPending.sidIssueDate.toString().substring(0, 10),
            sidExpDate: this.approvalPending.sidExpDate.toString().substring(0, 10),
            bioRefNo: this.approvalPending.bioRefNo,
            photoDate: this.approvalPending.photoDate,
            photoExpDate: this.approvalPending.photoExpDate,
            sidLostReason: this.approvalPending.sidLostReason,
            familyName: this.approvalPending.familyName,
            givenName: this.approvalPending.givenName,
            initialName: this.approvalPending.initialName,
            nicIssueDate: this.approvalPending.nicIssueDate,
            birthPlace: this.approvalPending.birthPlace,
            nationality: this.approvalPending.nationality,
            dob: this.approvalPending.dob,
           }
        );

        if(this.approvalPending.gender === 'Male') {
          this.male = true;
          this.female = false;
        }else {
          this.male = false;
          this.female = true;
        }

        // alert(this.approvalPending.dob+'dob...');
        // //if(this.approvalPending.dob != null)
        //   this.applicantSearchForm.value.dob = this.approvalPending.dob.toString().substring(0, 10);

        if(this.approvalPending.nicIssueDate != null)
          this.applicantSearchForm.value.nicIssueDate = this.approvalPending.nicIssueDate.toString().substring(0, 10);

        if(this.approvalPending.cancelSid) {
          this.isCancelled = true;
          this.notCancelled = false;
        } else {
          this.notCancelled = true;
          this.isCancelled = false;
        }

        if(this.approvalPending.debarredSid) {
          this.debarred = true;
          this.notDebarred = false;
        } else {
          this.notDebarred = true;
          this.debarred = false;
        }

      }
    );
  }

  view() {
    this.applicantRequestService.cardPreview(this.applicationId).subscribe(
      (data: any) => {
        const file = new Blob([data], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL,"_blank",  "width=800,height=400");

      },
      error => {
        this.isLoading = false;
        console.log(error);
      }
    );
  }

  openModelPreview() {
    this.showdiv = true;
  }

  viewDoc(documentTypeCode:string) {
    this.showdiv2 = true;
    this.getPages(documentTypeCode);
  }
}
